import { zipSync } from 'fflate';
import { ZipEntry } from 'interfaces/target_qr_download.interface';

// Packs files into one zip. Stored, not compressed: the entries are images, which are already
// compressed, so deflating them again costs time and saves nothing.
export const createZip = (entries: ZipEntry[]): Uint8Array => {
  if (entries.length === 0) {
    throw new Error('No files to zip');
  }
  const files: Record<string, Uint8Array> = {};
  entries.forEach((entry) => {
    files[entry.path] = entry.data;
  });
  return zipSync(files, { level: 0 });
}
